import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

export default function IntroPopup() {
  const [open, setOpen] = useState(true);

  return (
    <>
      {/* Or this: */}
      <button
        className="what-is-this-icon-btn"
        aria-label="What is this?"
        onClick={() => setOpen(true)}
      >
        ?
      </button>

      {/* actual popup */}
      <Popup
        open={open}
        modal
        closeOnDocumentClick
        onClose={() => setOpen(false)}
      >
        <div className="intro-popup-card">
          <h2 className="intro-popup-title">How Tap Beads Works</h2>
          <p className="intro-popup-text">
            🧵 Hey! Welcome to the site ✨<br /><br />
            Tap a little message, and we turn it into a bead-bracelet kit.
            You get just the beads you need, laid out in order and ready to
            string — a tiny message someone can take with them every day.
          </p>

          <button
            className="intro-continue-btn"
            onClick={() => setOpen(false)}
          >
            Continue
          </button>
        </div>
      </Popup>
    </>
  );
}
